import React = require('react');
import {Places, IItem as IPlacesItem} from "./edit_item/Places";
import {Schools, IItem as ISchoolsItem} from "./edit_item/Schools";
import {Jobs, IItem as IJobsItem} from "./edit_item/Jobs";
import {Honors, IItem as IHonorItem} from "./edit_item/Honors";
import {Army, IItem as IArmyItem} from "./edit_item/Army";
import {Languages, IItem as ILanguageItem} from "./edit_item/Languages";
import {Hobbies, IItem as IHobbiesItem} from "./edit_item/Hobbies";
import {Select, ISelectItem} from "../lib/components/Select";

export interface IProfileFormFieldsProps {
    itemPlaces   :Array<IPlacesItem>
    itemSchools  :Array<ISchoolsItem>
    itemJobs     :Array<IJobsItem>
    itemHonors   :Array<IHonorItem>
    itemArmy     :Array<IArmyItem>
    itemLanguages:Array<ILanguageItem>
    itemHobbies  :Array<IHobbiesItem>
    religion     :number
    nameDayMonth :number
    nameDayDay   :number
    note         :string
    changeHandler?:Function
    viewMode     :boolean
}

interface IProfileFormFieldsState {
	religions:Array<ISelectItem>
}

export class ProfileFormFields extends React.Component<IProfileFormFieldsProps, IProfileFormFieldsState>{

  	constructor(props:IProfileFormFieldsProps){
		super(props);
		this.state = {
			religions: [
				{
					name: 'Katolikus',
					id: 1,
					selected: false
				},
				{
					name: 'Református',
					id: 2,
					selected: false
				},
			],
		} as IProfileFormFieldsState;
    }

	private religionChangeHandler(id): void {
        this.modifyProps('religion', id);
	}

	protected getMonth(selectedId:number, placeholder:string):Array<ISelectItem>{
        var ret:Array<ISelectItem> = [{
            name: placeholder,
            id: 0,
            selected: false
        }];
        for (let i = 1; i < 13; i++) {
            ret.push({
                name: i.toString(),
                id: i,
                selected: selectedId===i ? true : false
            });
        }
        return ret;
    }

    protected getDays(selectedId:number, placeholder:string):Array<ISelectItem>{
        var ret:Array<ISelectItem> = [{
            name: placeholder,
            id: 0,
            selected: false
        }];
        for (let i = 1; i < 32; i++) {
            ret.push({
                name: i.toString(),
                id: i,
                selected: selectedId===i ? true : false
            });
        }
        return ret;
    }

    private modifyProps(fieldName:string, value:any):void{
        var props = JSON.parse(JSON.stringify(this.props));
        props[fieldName] = value;
        this.props.changeHandler(props);
    }

    private getReligions():Array<ISelectItem>{
        var ret:Array<ISelectItem> = [];
        for (var key in this.state.religions) {
            var item = this.state.religions[key];
            if ( this.props.religion === item.id ) {
                item.selected = true;
            }
            ret.push(item);
        }
        return ret;
    }

    render() {
        var religions = this.getReligions();
        return (
            <div className={ this.props.viewMode===true?'view_mode':''}>
                { this.props.viewMode===false || this.props.itemPlaces.length > 0? <div>
                    <legend>
                        Lakhelyek
                    </legend>
                    <Places
                        items={ this.props.itemPlaces }
                        itemChangeHandler={ items => this.modifyProps('itemPlaces', items) }
                        viewMode={ this.props.viewMode }
                        />
                </div>:'' }


                { this.props.viewMode===false || this.props.itemSchools.length > 0? <div>
                    <legend>
                        Iskolák
                    </legend>
                    <Schools
                        items={ this.props.itemSchools }
                        itemChangeHandler={ items => this.modifyProps('itemSchools', items) }
                        viewMode={ this.props.viewMode }
                    />
                </div>:'' }


                { this.props.viewMode===false || this.props.itemJobs.length > 0? <div>
                   <legend>
                        Munkahely
                    </legend>
                    <Jobs
                        items={ this.props.itemJobs }
                        itemChangeHandler={ items => this.modifyProps('itemJobs', items) }
                        viewMode={ this.props.viewMode }
                    />
                </div>:'' }

                { this.props.viewMode===false || this.props.itemHonors.length > 0? <div>
                    <legend>
                        Elismerések/Érdemrendek
                    </legend>
                    <Honors
                        items={ this.props.itemHonors }
                        itemChangeHandler={ items => this.modifyProps('itemHonors', items) }
                        viewMode={ this.props.viewMode }
                    />
                </div>:'' }

                { this.props.viewMode===false || this.props.itemArmy.length > 0? <div>
                    <legend>
                        Katonaság
                    </legend>
                    <Army
                        items={ this.props.itemArmy }
                        itemChangeHandler={ items => this.modifyProps('itemArmy', items) }
                        viewMode={ this.props.viewMode }
                    />
                </div>:'' }

                { this.props.viewMode===false || this.props.itemLanguages.length > 0? <div>
                    <legend>
                        Beszélt nyelvek
                    </legend>
                    <Languages
                        items={ this.props.itemLanguages }
                        itemChangeHandler={ items => this.modifyProps('itemLanguages', items) }
                        viewMode={ this.props.viewMode }
                    />
                </div>:'' }

                { this.props.viewMode===false || religions.length > 0? <div>
                    <legend>
                        Vallás
                    </legend>
                    <div className={this.props.viewMode===true?'view_mode':'mrb20'}>
                        <Select enableNewItem={false} multifield_mode={false} items={ religions } key="religion" itemChangeHandler={ id => this.religionChangeHandler(id) } viewMode={ this.props.viewMode }/>
                    </div>
                </div>:'' }

                { this.props.viewMode===false || this.props.itemHobbies.length > 0? <div>
                    <legend>
                        Hobbi
                    </legend>
                    <Hobbies
                        items={ this.props.itemHobbies }
                        itemChangeHandler={ items => this.modifyProps('itemHobbies', items) }
                        viewMode={ this.props.viewMode }
                    />
                </div>:'' }
                <div>

                </div>

                { this.props.viewMode===false || (this.props.nameDayMonth > 0 && this.props.nameDayDay > 0)? <div>
                    <legend>
                   Névnap
                    </legend>
                    { this.props.viewMode === true?<div className="view_mode">
                        <Select enableNewItem={false} multifield_mode={false} items={ this.getMonth(this.props.nameDayMonth, 'hónap') } key="getnamemonth" itemChangeHandler={ id => this.modifyProps('nameDayMonth', id)  } viewMode={ this.props.viewMode }/>. hónap <Select enableNewItem={false} multifield_mode={false} items={ this.getDays(this.props.nameDayDay, 'nap') } key="getnameday" itemChangeHandler={ id => this.modifyProps('nameDayDay', id) } viewMode={ this.props.viewMode }/>. nap
                    </div>:<div className="row">
                        <div className="box">
                            <Select enableNewItem={false} multifield_mode={false} items={ this.getMonth(this.props.nameDayMonth, 'hónap') } key="getnamemonth" itemChangeHandler={ id => this.modifyProps('nameDayMonth', id)  } viewMode={ this.props.viewMode }/>
                        </div>
                        <div className="box p5">
                            <Select enableNewItem={false} multifield_mode={false} items={ this.getDays(this.props.nameDayDay, 'nap') } key="getnameday" itemChangeHandler={ id => this.modifyProps('nameDayDay', id) } viewMode={ this.props.viewMode }/>
                        </div>
                    </div> }
                </div>:'' }

                { this.props.viewMode===false || this.props.note !== ''? <div>
                    { this.props.viewMode === false?<br />:'' }
                    <legend>
                    Jegyzet
                    </legend>
                    { this.props.viewMode === true?<div className="view_mode">
                        { this.props.note }
                    </div>:<textarea value={ this.props.note } onChange={ e => this.modifyProps('note', e.target.value) } /> }
                </div>:'' }

			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/ProfileFormFields.tsx